import { useLocalStorage } from '@mantine/hooks';

export function useQueryDevTools() {
  const [queryDevTools, setQueryDevTools] = useLocalStorage({
    key: 'queryDevTools',
    defaultValue: false,
  });

  return { queryDevTools, setQueryDevTools };
}
